module.exports = __webpack_public_path__ + "static/pray-99515c830399181c6e8153ce0c3e6acc.gif";